import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getShippingRegionList (callback) {
    HTTP.get('shipping/region').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateRegionStatus (callback, params) {
    HTTP.put('shipping/region', params).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  deleteShippingRegion (callback, params) {
    HTTP.delete('shipping/region', {data: { 'id': params }}).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  addShippingRegion (callback, params) {
    HTTP.post('shipping/region', params).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      if (e.response.status === 400 && e.response.data.data.message === 'shipping region exceed limits') {
        callback(e.response)
      }
      console.log(e)
    })
  },
  getShippingRegionById (callback, params) {
    HTTP.get('shipping/region/' + params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setShippingRegionName (callback, params) {
    HTTP.put('shipping/region_name', params).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getShippingItem (callback, shippingItemId) {
    HTTP.get(`shipping/item/${shippingItemId}`).then(response => {
      if (response.status === 200) {
        callback(response)
      }
    }).catch(e => {
      console.log(e)

      if (e.response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (e.response.status === 401) {
        HttpFunctions.response401()
      }
    })
  },
  setShippingItem (callback, params) {
    HTTP.put('shipping/item', params).then(response => {
      if (response.status === 201) {
        callback(response)
      }
    }).catch(e => {
      console.log(e)

      if (e.response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (e.response.status === 401) {
        HttpFunctions.response401()
      }
    })
  },
  getShippingItems (callback, params) {
    HTTP.get('shipping/items/' + params).then(response => {
      if (response.status === 200) {
        callback(response)
      }
    }).catch(e => {
      console.log(e)

      if (e.response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (e.response.status === 401) {
        HttpFunctions.response401()
      }
    })
  },
  getShippingType (callback, params) {
    HTTP.get('shipping/type?lang=' + params).then(response => {
      if (response.status === 200) {
        callback(response)
      }
    }).catch(e => {
      console.log(e)

      if (e.response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (e.response.status === 401) {
        HttpFunctions.response401()
      }
    })
  },
  getCountry (callback, params) {
    HTTP.get('shipping/country/' + params[0] + '?language=' + params[1]).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateRegionCountry (callback, params) {
    HTTP.put('shipping/country', params).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  deleteRegionCountryByCountryId (callback, params) {
    HTTP.delete('shipping/country?language=' + params.language, { data: params }).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setShippingRegionTypeSort (callback, params) {
    if (params !== undefined) {
      HTTP.put('shipping/items/sort', params).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  setShippingItemStatus (callback, params) {
    HTTP.put('shipping/item/status', params).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 400) {
        console.log('Error: method&status are required')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  deleteShippingItem (callback, params) {
    if (params !== undefined) {
      HTTP.delete('shipping/item', {data: params}).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getAllThaiProvice (callback, params) {
    HTTP.get('account/province?language=' + params[0]).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateShippingType (callback, params) {
    HTTP.put('shipping/type', params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateProvince (callback, params) {
    HTTP.put('shipping/province', params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getShippingProvinceById (callback, params) {
    HTTP.get('shipping/province/' + params).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  deleteThaiProvinceByProvinceId (callback, params) {
    HTTP.delete('shipping/province?language=' + params.language, { data: params }).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getDefaultShippingOtherAreaData (callback) {
    HTTP.post('shipping/region/default').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getShippingAllThaiProvinceByRegionId (callback, params) {
    HTTP.get('shipping/all/province?language=' + params[0]).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  saveShippingItemList (callback, params) {
    HTTP.put('shipping/items/list', params).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  deleteShippingItemList (callback, params) {
    HTTP.delete('shipping/items/list', {data: params}).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/shipping/index.js